export default __webpack_public_path__ + "static/media/Ch4d.bd0ba2de.gif";